import React from 'react';
import './AddMembers.css';

export default function AddMembers() {
  return (
    <div className="add-members-container">
      <div className="page-header">
        <h1>Add Members</h1>
        <p>Add new members to your organization</p>
      </div>
      
      <div className="page-content">
        <p>This page is under construction. Add member functionality will be implemented here.</p>
      </div>
    </div>
  );
}
